import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  header: css`
    padding-block-start: ${spacing(2.5)};
  `,
  body: css`
    padding-block-start: ${spacing(0.5)} !important;
    // по-умолчанию overflow-y: auto
    overflow: hidden !important;
  `,
}
